"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenResource = flattenResource;
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/entries"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/json/stringify"));
var _handleError = require("../../handle-error");
function flattenResource(resource) {
  const result = {};
  if (!resource || typeof resource !== 'object') {
    (0, _handleError.handleError)(`Expected object, got ${typeof resource}`);
    return {};
  }
  for (const [key, resourceEntry] of (0, _entries.default)(resource)) {
    try {
      if (!isValidTranslation(resourceEntry)) {
        (0, _handleError.handleError)(`Invalid value for ${key}: ${(0, _stringify.default)(resourceEntry)}`);
        continue;
      }
      if (typeof resourceEntry === 'string') {
        result[key] = resourceEntry;
      } else if (typeof resourceEntry.translation === 'string') {
        result[key] = resourceEntry.translation;
      } else {
        result[`${key}_one`] = resourceEntry.translation.one;
        result[`${key}_other`] = resourceEntry.translation.other;
      }
    } catch (err) {
      (0, _handleError.handleError)(err);
      continue;
    }
  }
  return result;
}
function isValidTranslation(value) {
  if (typeof value === 'string') {
    return true;
  }
  const isLocaleTemplateEntry = value && typeof value === 'object' && 'translation' in value;
  const isLocaleTemplateEntrySingular = isLocaleTemplateEntry && typeof value.translation === 'string';
  const isLocaleTemplateEntryPlural = isLocaleTemplateEntry && value.translation && typeof value.translation === 'object' && 'one' in value.translation && typeof value.translation.one === 'string' && 'other' in value.translation && typeof value.translation.other === 'string';
  if (isLocaleTemplateEntrySingular || isLocaleTemplateEntryPlural) {
    return true;
  }
  return false;
}